import{s as r}from"../classes/semver.js";const s=r;var e=(r,e,n,t,o)=>{"string"==typeof n&&(o=t,t=n,n=void 0);try{return new s(r instanceof s?r.version:r,n).inc(e,t,o).version}catch(r){return null}};export{e as i};
